import logo from '../assets/bnc-k.svg'; // adjust path as needed

const BncLogoSpinner = ({ size = 100 }) => (
	<div className="bnc-spinner-container" style={{ width: size, height: size }}>
		<img src={logo} alt="BNC Logo" className="bnc-logo" />
		<svg
			className="bnc-spinner"
			viewBox="0 0 100 100"
			width={size}
			height={size}
		>
			<circle
				className="bnc-spinner__arc"
				cx="50"
				cy="50"
				r="45"
				fill="none"
				stroke="#E3202B"
				strokeWidth="8"
				strokeDasharray="283" /* 2πr */
				strokeDashoffset="75" /* starting gap */
				strokeLinecap="round"
			/>
		</svg>
	</div>
);

export default BncLogoSpinner;
